import type React from 'react';

export interface NotificationBellProps {
	width?: string | number;
	height?: string | number;
	color?: string;
	'aria-label'?: string;
}

const NotificationBell: React.FC<NotificationBellProps> = ({
	width = 20,
	height = 22,
	color = 'currentColor',
	'aria-label': ariaLabel = 'Notifications Bell Icon',
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 20 22"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-label={ariaLabel}
		style={{ color }}
	>
		<path
			d="M17.0936 13.9813C16.7709 13.4657 16.5996 12.8696 16.5993 12.2613V7.75673C16.5993 5.89843 15.8611 4.11624 14.547 2.80223C13.233 1.48821 11.4508 0.75 9.59253 0.75C7.73423 0.75 5.95204 1.48821 4.63802 2.80223C3.324 4.11624 2.5858 5.89843 2.5858 7.75673V12.2591C2.58588 12.8682 2.41456 13.465 2.09142 13.9813L0.914434 15.8636C0.812089 16.0274 0.755441 16.2156 0.750373 16.4086C0.745304 16.6016 0.792 16.7925 0.885611 16.9614C0.979222 17.1303 1.11634 17.2711 1.28272 17.3691C1.4491 17.4671 1.63869 17.5188 1.83179 17.5188H17.3533C17.5464 17.5188 17.736 17.4671 17.9023 17.3691C18.0687 17.2711 18.2058 17.1303 18.2994 16.9614C18.3931 16.7925 18.4398 16.6016 18.4347 16.4086C18.4296 16.2156 18.373 16.0274 18.2706 15.8636L17.0936 13.9813Z"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M7.42773 20.7641C8.73137 21.2224 10.1472 21.2528 11.4693 20.8509L11.7549 20.7641"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
		/>
	</svg>
);

export default NotificationBell;

